import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { userRoles } from '../../../data/admin-master-data';
import { SuperAdminService } from '../../../services/super-admin.service';
import { Router } from '@angular/router';
import { MaterialPageGrid } from '../../../utils/material-page-grid';
@Component({
  selector: 'app-list-roles-vs-prev',
  templateUrl: './list-roles-vs-prev.component.html',
  styleUrls: ['./list-roles-vs-prev.component.scss'],
})
export class ListRolesVsPrevComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  resultsPageGrid: MaterialPageGrid;
  gridInProgress = false;
  userRoles = userRoles;
  roleNames: string[] = [];
  displayedColumns: string[] = [];

  constructor(private superAdminService: SuperAdminService, private router: Router, private fb: FormBuilder) {}

  async ngOnInit() {
    await this.initGrid();
  }

  async initGrid() {
    // Get initial data to determine columns
    const initialData = await this.superAdminService.roleDetails();
    this.roleNames = initialData.roleNames || [];

    // Create dynamic columns array
    this.displayedColumns = ['privilege', ...this.roleNames];

    this.resultsPageGrid = new MaterialPageGrid(this.fb, 15)
      .setTableColumns(this.displayedColumns)
      .setSource(async (listQuery) => {
        try {
          this.gridInProgress = true;
          const data = await this.superAdminService.roleDetails();
          this.gridInProgress = false;

          return {
            data: data.roleDetails || [],
            total: (data.roleDetails || []).length,
          };
        } catch (error) {
          this.gridInProgress = false;
          return { data: [], total: 0 };
        }
      })
      .setFilters({
        searchPrivilege: '',
      });

    // Attach sort and paginator after view init
    setTimeout(() => {
      if (this.sort) {
        this.resultsPageGrid.attachSort(this.sort);
      }
      if (this.paginator) {
        this.resultsPageGrid.attachPaginator(this.paginator);
      }
    });
  }
  searchByPrivilege(privilege) {
    this.superAdminService.emit({ role: null, prive: privilege });
    this.router.navigate(['/super-admin/user-management/manage-users']);
  }
  searchByRole(role) {
    this.superAdminService.emit({ role: role, prive: null });
    this.router.navigate(['/super-admin/user-management/manage-users']);
  }
}
